import React, { memo, useEffect, useState } from 'react';
import { Fade } from 'react-reveal';

const Segments = ({
  list,
  index = 0,
  duration = 500,
  delay = 0,
  onAnimationEnd = () => {},
  className = '',
  animateFromTop = false,
}: any) => {
  const [currentIndex, setCurrentIndex] = useState<number>(index);
  const [animateFromBottom, setAnimateFromBottom] = useState<boolean>(!animateFromTop);

  useEffect(() => {
    if (currentIndex !== index) {
      setAnimateFromBottom(currentIndex < index || currentIndex > index + 1);
      setCurrentIndex(index);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, setCurrentIndex]);

  return (
    <Fade
      bottom={animateFromBottom}
      top={animateFromTop || !animateFromBottom}
      spy={list[currentIndex]}
      duration={duration}
      delay={delay}
      onReveal={onAnimationEnd}
    >
      <div className={className}>{list[currentIndex]}</div>
    </Fade>
  );
};

export default memo(Segments);
